export default __webpack_public_path__ + "static/media/frog.ff5d52f3.jpg";